import { ThemeModeProvider, Toaster } from "@template/ui";
import { store } from "@template/state";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "./router/AppRouter";

export default function App() {
  return (
    <Provider store={store}>
      <ThemeModeProvider>
        <Toaster />
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ThemeModeProvider>
    </Provider>
  );
}
